import { IEventSubscriber } from "./IEventSubscriber";
import { Assert } from "../Utils/Assert";

export class EventPublisher {
    private _registrations: Map<IEventSubscriber, () => void> = new Map<IEventSubscriber, () => void>();

    public register(subscriber: IEventSubscriber, onDispatch: () => void): void {
        Assert(!this._registrations.has(subscriber), "EventPublisher.register: This subscriber is already registered.");
        this._registrations.set(subscriber, onDispatch);
    }

    public unregister(subscriber: IEventSubscriber): void {
        Assert(this._registrations.has(subscriber), "EventPublisher.unregister: This subscriber is not registered.");
        this._registrations.delete(subscriber);
    }

    public dispatch(): void {
        this._registrations.forEach((callback) => callback());
    }
}
